module.exports = __webpack_public_path__ + "static/img/TR-foundation-horizontal.10d8b3ca.svg";